import { isPresent } from "src/utils/checks";

export const shorexSplitNewFeature = <T extends { code?: string }>(
  featureCodes: string[] = [],
  content: (T | undefined)[] = []
) => {
  const contentForActiveFeature = featureCodes
    .map((code) => content.find((f) => f && f.code === code))
    .filter(isPresent);

  const featureNew = contentForActiveFeature?.find((f) => f.code === "new");
  const otherFeatures = contentForActiveFeature?.filter(
    (f) => f.code !== "new"
  );

  return {
    featureNew,
    otherFeatures
  };
};
